import React from 'react';
import SectionLiveTab from '../containers/SectionLiveTab/SectionLiveTabNew';
import { LivePageContentWrapper } from './styled';
import { detectMobile } from '../utils/UiHelper';
import { connect } from 'react-redux';
import Footer from '../components/Footer';

const LiveEventsPage = (props) => {
    return (
        <>
            <LivePageContentWrapper
                className="live-event-page"
                isLeftSideBarOpen={props.isLeftSideBarOpen}
                isMobile={detectMobile()}
            >
                <SectionLiveTab />
            </LivePageContentWrapper>
            {detectMobile() ? <Footer /> : null}
        </>
    );
};

function mapStateToProps(state) {
    return {
        isLeftSideBarOpen: state.ui.leftSidebarOpen,
    };
}

export default connect(
    mapStateToProps,
    null
)(LiveEventsPage);
